import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Api } from 'src/app/core/api/Api';

@Injectable({
  providedIn: 'root',
})
export class CreateTenantService {
  constructor(private http: HttpClient) {}

  createTenant(payload) {
    return this.http.post(Api.Tenant, payload);
  }
}
